import { useTranslation } from 'react-i18next';

import { plural } from '@hotjar/webapp/lib/plural';

interface UseTranslatedClickEventProps {
  count: number;
  isDesktop: boolean;
}

export const useTranslatedClickEvent = ({
  count,
  isDesktop,
}: UseTranslatedClickEventProps): string => {
  const { t } = useTranslation();

  const desktopEventName = plural(
    {
      one: t('highlights:heatmaps.stats.click'),
      other: t('highlights:heatmaps.stats.clicks'),
    },
    count,
  );
  const mobileEventName = plural(
    { one: t('highlights:heatmaps.stats.tap'), other: t('highlights:heatmaps.stats.taps') },
    count,
  );

  return isDesktop ? desktopEventName : mobileEventName;
};
